import {useHBStore} from 'hb-redux-store/root.hooks.js';

import {selectCartDetails} from 'hb-redux-store/feature/cart/cart.selectors';

import {
  postAddItem,
  postRemoveItem,
  scratchCard,
  showCart,
} from 'hb-redux-store/feature/cart/cart.action';

export const useCartDetails = () => {
  const {state, dispatch} = useHBStore();
  const cartDetails = selectCartDetails(state);
  return {
    cartDetails,
    postAddItem: payload => dispatch(postAddItem(payload)),
    postRemoveItem: payload => dispatch(postRemoveItem(payload)),
    scratchCard: payload => dispatch(scratchCard(payload)),
    showCart: () => dispatch(showCart()),
  };
};
